import React, {useCallback, useMemo, useRef, useState, useEffect} from 'react';
import {Helmet} from 'react-helmet';
import {Header, Titulo, ContenedorHeader} from './../elementos/Header';
import { GoogleMap, Marker, useJsApiLoader, useLoadScript } from '@react-google-maps/api';
import {  Contenedor, Controles, ContenedorMapa,BotonsRecarga,Icono } from '../elementos/ElementosMapa';
import useObtenerActivos from './../hooks/useObtenerActivos';
import BtnRegresar from "../elementos/BtnRegresar";
import BtnMapa from "../elementos/BtnMapa";
import iconActivo from './../imagenes/rojo.png';
import iconDisponible from './../imagenes/verde.png';
import useObtenerViajesActivos from './../hooks/useObtenerViajesActivos';


const Mapa = () => {
const conductores = useObtenerActivos();
const viajesActivos = useObtenerViajesActivos();

const [moviles, cambiarMoviles] = useState([]);

const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_APIKEY,
    libraries: ["places"]
    })
const centro = useMemo(() => ({lat: -33.43741517966219,lng: -70.65049628138881}),[]);
const activos = useMemo(() => conductores,[conductores])
const options = useMemo(() => ({
    mapId:"2a56e698e3a7992c",
    disableDefaultUI:true,
    clickableIcons: false,

}),[]);


useEffect(() => {
cambiarMoviles(conductores)
  }, [conductores]);

const onclick = () => {
    
    cambiarMoviles(conductores)
}

const mapContainerStyle = {width: "100%",height: "100%"}
const position = { lat: -33.43741517966219, lng: -70.65049628138881 };
const position2 = { lat: -33.412547292256114, lng: -70.79317996133058 };

const findElement = (array, searchedAge) => {
  return array.find(element => element.numero_m === searchedAge) ?? -1;
}


console.log(viajesActivos)
console.log(findElement(viajesActivos, "99").estado)
if (viajesActivos.hasOwnProperty("numero_m")){
 // console.log(viajesActivos.numero_m.includes("99"));
 console.log(viajesActivos[0])
}
/*
console.log(conductores[0].l[0])
console.log(conductores[0].l[1])
console.log(conductores[0].data.numero)
*/


//findElement(names, 19);     // { name: "Andrea", age: 19 }





const [show, setShow] = React.useState(false)

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      setShow(true)
    }, 2000)

    return () => clearTimeout(timeout)

  }, [show])

  if (!show) return null

  return (
		<>
			<Helmet>
				<title>Mapa</title>
			</Helmet>

			<Header>
				<ContenedorHeader>
                <BtnRegresar></BtnRegresar><BotonsRecarga to="/mapa"><Icono /></BotonsRecarga>
					<Titulo>Mapa de Ubicación de Móviles</Titulo>
				</ContenedorHeader>
			</Header>
           <Contenedor>
                <Controles>
                    <h1></h1>
                </Controles>
                <ContenedorMapa>
                <GoogleMap 
                zoom={11} 
                center={centro} 
                mapContainerStyle={mapContainerStyle}
                options={options}
                >{activos.map((conductor,index) => {
                  if(findElement(viajesActivos, conductor.numero_m).estado==="Activo"){
                    return( 
                      <Marker key={index} position={{ lat: conductor.lat, lng: conductor.lng }} label={conductor.numero_m} icon={iconActivo}/> 
                      )
                  }
                  else{
                    return( 
                      <Marker key={index} position={{ lat: conductor.lat, lng: conductor.lng }} label={conductor.numero_m} icon={iconDisponible}/> 
                      
                      )
                  }

                  }
                    )
                    
                 }
                </GoogleMap>
                    
                </ContenedorMapa>

           </Contenedor>
		</>
	);
}

export default Mapa;